import { getCurrencySymbol } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { sortString } from '@common/helpers/utils';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationDbService } from '@shared/database/organization-db-service';
import { EcosystemServiceModel } from '@shared/models/ecosystem-service.model';
import { ProjectModel } from '@shared/models/project.model';
import { DiscountRateModel } from '@shared/models/setting.model';
import { SettingService } from '@shared/services/setting.service';
import { NgxPermissionsService, NgxRolesObject, NgxRolesService } from 'ngx-permissions';
import { ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { DialogService } from "primeng/dynamicdialog";
import { ECOSERVICES } from 'projects/shared-lib/src/data/ecoservices-def';
// import { ProviderDbService } from 'projects/shared-lib/src/database/provider-db.service';
// import { Provider } from 'projects/shared-lib/src/models/provider.model';
import { UserDbService } from 'projects/shared-lib/src/database/user-db-service';
import { UserModel } from 'projects/shared-lib/src/models/user.model';
import { Observable, switchMap, shareReplay, of, BehaviorSubject, tap, map, distinctUntilChanged, take, combineLatest } from 'rxjs';
// import { AuthComponent } from '../components/auth/auth.component';
import { AuthService } from './auth.service';
import { ExerciseEcoserviceDbService } from '@shared/database/exercise-ecoservice-db-service';

type AppMode = 'admin' | 'provider'

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private activeMode: BehaviorSubject<AppMode> = new BehaviorSubject('provider');
  activeMode$ = this.activeMode.asObservable();
  loading: boolean = false;
  private _sideBarProject = false
  private _sideBarExercise = false
  public _projectExercise = null;
  private _language: BehaviorSubject<string> = new BehaviorSubject('en');
  language$ = this._language.asObservable();



  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    private http: HttpClient,
    private dialogService: DialogService,
    private authService: AuthService,
    private userDbService: UserDbService,
    // private providerDbService: ProviderDbService,
    private rolesService: NgxRolesService,
    private permissionsService: NgxPermissionsService,
    private router: Router,
    private translateService: TranslateService,
    private primengConfig: PrimeNGConfig,
    public confirmationService: ConfirmationService,
    private organizationDbService: OrganizationDbService,
    private settingService: SettingService,
    private exerciseEcoserviceDbService: ExerciseEcoserviceDbService,
  ) {
    this.permissionsService.permissions$.subscribe((permissions) => {
      // if(!isEmpty(permissions) && !permissions["canProvider"]){
      //   // this.changeMode('admin');
      // }
      // console.log("permissions", permissions)
    })
  }

  getCurrencySymbol = (currency: string) => getCurrencySymbol(currency, 'wide', this.localeId);

  countries$ = this.http.get<any>('./assets/data/countries.json').pipe(
    map(countries => countries.map(c => ({ name: c.Name, iso2: c.Iso2 })).sort(sortString)),
    shareReplay(1)
  )

  currencies$ = this.http.get<any>('./assets/data/currencies.json').pipe(
    // map(currencies=>Object.keys(currencies).sort()),
    map(currencies => Object.values(currencies)), // allow showing the name and symbol, and other fields for full filtering
    shareReplay(1),
  )

  languages = [
    { id: 'es', name: "Español" },
    { id: 'en', name: "English" },
  ]


  /*********************
   * Organizations
  **********************/
  organizations$ = this.organizationDbService.getAll$().pipe(shareReplay(1));

  /*** End Organizations */

  /********************
   * Ecoservices Block
   *********************/
  get ecoservices$(): Observable<Array<Partial<EcosystemServiceModel>>> {
    return of(ECOSERVICES)
  }
  /*** End Ecoservices block */


  /**********************
   * Exercice block
   **********************/

  get showNewExercise() {
    return this._sideBarExercise;
  }
  set showNewExercise(value) {
    if (!value) {
      this._projectExercise = null;
    }
    this._sideBarExercise = value;
  }
  createExercise(project: ProjectModel) {
    if (project) {
      this._projectExercise = project;
      this._sideBarExercise = true;
    }
  }

  endCreateExercise(projectId = null, exerciseId = null) {
    this._projectExercise = null;
    this._sideBarExercise = false;
    if (projectId && exerciseId) {
      this.router.navigate(['projects', projectId, 'edit', exerciseId]);
    }
  }

  visibleExerciseEcoserviceItems$ = (exerciseId: string) => combineLatest([
    this.exerciseEcoserviceDbService.queryBy$({ 'exercise.id': exerciseId }),
    this.ecoservices$,
  ]).pipe(
    map(([exerciseEcoservices, ecoservices]) => {
      return exerciseEcoservices
        .filter(e => e.status !== 'disable')
        .map(e => { // serviceType is not part of reference :(
          const serviceType = ecoservices?.find(es => es.id == e.ecoservice.id)?.serviceType;
          return { id: e.ecoservice.id, serviceType, pos: e.ecoservice.pos ?? 0 };
        })
        .sort((a, b) => (a.pos - b.pos)) as Array<{ id: string, name: string, serviceType: string, pos: number }>;
    }),
    // tap(c => console.log('visibleExerciseEcoserviceRefs', c)),
    shareReplay(1)
  );
  /*** End Exercice block */

  /*********************
   * Settings
   *********************/

  public discountRates$: Observable<DiscountRateModel> = this.settingService.discountRates$.pipe(shareReplay(1));

  /*********En Settings ********/

  /*********************************
   * Project block
   ********************************/
  public activeProject$ = new BehaviorSubject<ProjectModel>(null);

  get activeProject() {
    const activeProject = this.activeProject$.value;
    return activeProject;
  }

  get showNewProject() {
    return this._sideBarProject;
  }

  set showNewProject(value) {
    this._sideBarProject = value;
  }

  createProject() {
    this._sideBarProject = true;
  }

  endCreateProject(projectid) {
    this._sideBarProject = false;
    if (projectid) {
      this.router.navigate(['projects', projectid, 'edit']);
    }
  }

  activeProjectBaseline$ = this.activeProject$.pipe(
    map(project => project?.baseline),
    distinctUntilChanged(),
    shareReplay(1),
  );

  /***   End project block */


  /***************************
   * User Block
   ***************************/

  user$ = this.authService.user$.pipe(
    tap(user => {
      // if (user){
      //   // && !user.roles.includes(UserModel.Role.PROVIDER)
      //   let roles =
      //   console.log("Roles", roles);
      //   this.changeMode('admin');
      // }
    })
  );

  userProfile$: Observable<UserModel> = this.authService.user$.pipe(
    switchMap(userAuth => userAuth ? this.userDbService.get$(userAuth.uid) : of(null)),
    shareReplay(1)
  );
  /***   End user block */

  showDialog() {
  }

  async signout() {
    await this.authService.signOut();
    this.router.navigate(['login'])
  }

  startLoading() {
    this.loading = true;
  }

  stopLoading() {
    this.loading = false;
  }

  get language() {
    return this._language.value;
  }
  set language(value) {
    this.changeLanguage(value);
  }

  changeLanguage(locale: string, options: any = {}): void {
    const { reload = true } = options;
    this.savedLanguage = locale;
    this._language.next(locale);
    this.translateService.use(locale);
    this.translateService.get('primeng').pipe(take(1)).subscribe(res => this.primengConfig.setTranslation(res));
    // console.log("Cambia Language", locale);
    if (reload) { window.location.reload() };
    // TODO: aquí no falta setear el locale de los dates?
  }

  get savedLanguage() {
    return localStorage.getItem('language') ?? 'en';
  }

  set savedLanguage(language: string) {
    localStorage.setItem('language', language);
  }

}
